import _ from 'lodash'

export function getServerUrl(platform) {
	const host = platform.server?.replace(`:${platform.port}`, '')
	return platform.mode === 'srt'
		? `${host}:${platform.port}${platform.key ? '?streamid=' + platform.key : ''}`
		: platform.server
}

export function getYoutubeChannelUrl(url) {
	if (!url) return ''
	const base = 'https://www.youtube.com/channel/'
	if (!url.startsWith(base)) return url
	const channelId = url.substring(base.length)
	if (!channelId) return url
	return `https://studio.youtube.com/channel/${channelId}/livestreaming/manage`
}

export function composePlatformPushUrl(platform) {
	if (!platform) return
	let pushUrl = platform.server
	pushUrl = pushUrl.replace(/\/$/g, '')
	if (pushUrl.indexOf('ustream.tv') > -1 || pushUrl.indexOf('secdn.net') > -1) {
		pushUrl += '/'
	}
	if (!pushUrl.includes('srt://')) {
		pushUrl += '/' + platform.key
	}
	return pushUrl
}

export function computePlatformStatus(platformPushUrl, mediaPulse) {
	let isSrt = false
	let srtPlatformKey = null
	if (platformPushUrl.includes('#!::r=') || platformPushUrl.includes('srt://')) {
		srtPlatformKey = new URL(platformPushUrl).hash
		isSrt = true
	}
	let connected = false
	if (mediaPulse && mediaPulse.push_stats && !_.isEmpty(mediaPulse.push_stats)) {
		let pushedBytes = mediaPulse.push_stats[isSrt ? srtPlatformKey : platformPushUrl]
		if (!pushedBytes && !_.isEmpty(mediaPulse.push_stats)) {
			_.forEach(mediaPulse.push_stats, (val, key) => {
				const item = _.assign(val, { url: key })
				if (item.url && item.url === platformPushUrl) pushedBytes = item
				if (item.url.includes('srt://')) {
					const statsHost = new URL(item.url).host
					const platformHost = new URL(platformPushUrl).host
					if (statsHost === platformHost) pushedBytes = item
				}
			})
		}
		if (pushedBytes) {
			connected = pushedBytes.sent_bytes > 0 || pushedBytes.bytes > 0
		}
	}
	return connected
}

export function pushStreamFailOverEnabled(platform) {
	return _.get(platform, ['streamObject', 'failoverIngest'], false)
}

export function getLinkedSourceTooltip(platform) {
	return platform.linkedSource
		? `Cannot be edited. This is the source for ${platform.streamObject ? platform.streamObject.name : platform.name} livestream.`
		: ''
}

export function getCountryFlag(region, regions = []) {
	if (regions.length > 0) {
		const identifier = regions.find(reg => reg.name === region)?.identifier
		return `https://assets.castr.io/countryflags/${identifier}/flat/64.png`
	}
	return `https://assets.castr.io/countryflags/${region}/flat/64.png`
}

export function regionName(platform) {
	return platform.streamObject?.uiRegion?.name
		|| platform.streamObject?.region?.name
		|| platform.region
}
